import ThemeConfig from "../common/components/ThemeSwitcher/ThemeConfig";

const themes = ["theme-light", "theme-dark"];

if (!ThemeConfig.IsThemeInitialized() && ThemeConfig.ThemeInit());
window.addEventListener("storage", () => ThemeConfig.ThemeInit());
